<template>
  <div ref="divider">
    <el-divider>
      {{ content }}
    </el-divider>
  </div>
</template>

<script>
export default {
  name: 'TDivider',
  props: {
    color: {
      type: String,
      default: '#dcdfe6'
    },
    content: {
      type: String,
      default: ''
    },
    borderStyle: {
      type: String,
      default: 'solid'
    }
  },
  watch: {
    color(val) {
      this.$refs.divider.children[0].style.borderTop = `2px ${val} ${this.borderStyle}`
    },
    borderStyle(val) {
      this.$refs.divider.children[0].style.borderTop = `2px ${this.color} ${val}`
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs.divider.children[0].style.borderTop = `2px ${this.color} ${this.borderStyle}`
      this.$refs.divider.children[0].style.backgroundColor = 'transparent'
      this.$refs.divider.children[0].style.height = ''
    })
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-divider__text {
  max-width: 90%;
  width: max-content;
  padding: 0 6px;
  text-align: center;
}
</style>
